/* eslint-disable no-script-url */
export const ACCESSORIES = "accessories";
export const VACUUMMODEL = "vacuummodel";
export const MENU = [
  { href: "#home", icon: "fa fa-home", text: "HOME" },
  { href: "#introduction", icon: "fa fa-desktop", text: "INTRODUCTION" },
  { href: "#help", icon: "fa fa-question-circle", text: "HELP" },
  { href: "#contact", icon: "fa fa-phone", text: "CONTACT" },
];
export const ADMIN_MENULIST = [
  {
    title: "Home",
    value: "home",
    name: "admin-home",
    href: "/admin-home",
    cssClass: "sidebar-dropdown",
    onClick: null,
    subMenu: [],
    Order: 1,
  },
  {
    title: "User Managment",
    value: "usermanagment",
    name: "user-management",
    href: "/user-management",
    cssClass: "sidebar-dropdown",
    onClick: null,
    subMenu: [],
    Order: 2,
  },
  {
    title: "Model Management",
    value: "modelmanagement",
    name: "model-management",
    href: "/model-management",
    cssClass: "sidebar-dropdown",
    onClick: null,
    subMenu: [],
    Order: 3,
  },
  {
    title: "Accessories Manag...",
    value: "accessoriesmanagement",
    name: "accessories-management",
    href: "/accessories-management",
    cssClass: "sidebar-dropdown",
    onClick: null,
    subMenu: [],
    Order: 4,
  },
  {
    title: "Account Management",
    value: "accountmanagement",
    name: "account-management",
    href: "Javascript:void(0)",
    cssClass: "sidebar-dropdown",
    onClick: "this.dropdownClick",
    subMenu: [
      {
        subMenuTitle: "Update Profile",
        subMenucssClass: "",
        href: "/account/update-profile",
        Order: 1,
      },
      {
        subMenuTitle: "Change Password",
        subMenucssClass: "",
        href: "/account/change-password",
        Order: 2,
      },
    ],
    Order: 5,
  },
];

export const ACCESSORY_IMAGES_PREFIX =
  process.env.REACT_APP_ENV === "local"
    ? process.env.REACT_APP_DEV_URL
    : window.location.origin;
